import { Button } from '~/components/Button';

import type { ScreenProps } from '.';
import ModalHeadings from './ModalHeadings';

type Props = ScreenProps & {
  email: string;
};

const SignUpComplete = ({ email, onDismiss }: Props) => {
  return (
    <>
      <ModalHeadings>
        <>
          We just sent an email to <strong>{email}</strong>
          <br /> It has a link that will sign you in to The Sole Supplier
        </>
      </ModalHeadings>
      <div className="flex w-full flex-col items-start gap-4 bg-black">
        <Button
          className="h-12"
          variant="green-human"
          onClick={() => onDismiss()}
        >
          Done
        </Button>
      </div>
    </>
  );
};

export default SignUpComplete;
